import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HoverDropDownButtonTemplate } from 'themes/components';

class HoverDropDownButton extends Component {
  render() {
    return <HoverDropDownButtonTemplate {...this.props} />;
  }
}

HoverDropDownButton.propTypes = {
  disabled: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onItemClick: PropTypes.func,
  children: PropTypes.node,
  text: PropTypes.string,
  buttonClass: PropTypes.string,
  iconClass: PropTypes.string,
  popupSettings: PropTypes.object,
  themeColor: PropTypes.string,
  fillMode: PropTypes.string,
  enableClickToggle: PropTypes.bool
};

HoverDropDownButton.defaultProps = {
  themeColor: 'primary',
  fillMode: 'solid',
  popupSettings: {},
  enableClickToggle: false
};

export default HoverDropDownButton;
